import { Component, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { VerifypatientService } from 'src/app/services/verifypatient.service';
import { VerifypatientModule, PatientPersonalInfo, getPatientDataByURl, auth } from 'src/app/models/verifypatient/verifypatient';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UpdateinfoService } from 'src/app/services/updateinfo.service';
import { IntakeMedicationService } from 'src/app/services/intake-Medication.service';
declare var $: any;
import * as LogRocket from 'logrocket';
import { TranslateService } from '@ngx-translate/core';
import  moment from 'moment';
import { PaymentDeiails } from 'src/app/models/registeration/payment_models';
import { PaymentService } from '../../services/payment.service';

@Component({
  selector: 'app-verify-patient',
  templateUrl: './verify-patient.component.html',
  styleUrls: ['./verify-patient.component.css']
})
export class VerifyPatientComponent implements OnInit {
  VerifypatientModule: VerifypatientModule;
  PatientPersonalInfo: PatientPersonalInfo;
  auth : auth;
  getPatientInfo: getPatientDataByURl = new getPatientDataByURl();
  maxDate: any;
  isLockScreen : boolean= false;
  currentTimeZone: any;
  selectedLanguage: any = 'en';
  selectedDay: any;
  selectedMonth: any;
  selectedYear: any;
  months: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  years: number[] = [];

  daysInMonth: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
  isAppointmentDetail: boolean = true;
  showThanksScreen: boolean = false;
  verifyPatientScreen: boolean = false;
  appStatusId: any
  landedFrom: any = "Text";
  currentLang: string = 'en';
  constructor(private renderer: Renderer2,private translateService: TranslateService,private _phrutilService: PhrutillsService, private _VerifypatientService: VerifypatientService, private spinner: NgxSpinnerService,
    private datepipe: DatePipe, private route: Router, private updateinfoservice: UpdateinfoService, private _route: ActivatedRoute, private medicationService: IntakeMedicationService, private service: PaymentService) {
      this.VerifypatientModule = new VerifypatientModule();
      this.PatientPersonalInfo = new PatientPersonalInfo();
      this.auth = new auth();
    }
  profileForm = new UntypedFormGroup({
      dobDay: new UntypedFormControl('', [Validators.required]),
      dobMonth: new UntypedFormControl('', [Validators.required]),
      dobyear: new UntypedFormControl('', [Validators.required])
    });
    
    
    ngOnInit(): void {
      let lang = localStorage.getItem('language');
      if (lang) {
        this.currentLang = lang;
        this.selectedLanguage = lang;
      } else {
        this.currentLang = 'en';
        this.selectedLanguage = 'en'
      }
      this.getCurrentTimeZone();
      this.populateYears();
      let accessLink = sessionStorage.getItem('AccessLink');
      this.maxDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
      this._route.queryParams.subscribe((params: Params) => {
        localStorage.clear();

        localStorage.setItem('language', this.selectedLanguage);
        if (params['testing'] != null) {
          localStorage.setItem("testing", params['testing']);
        } else {
          localStorage.removeItem("testing");

        }
        if(params['lock-screen']!=null ){
          if(accessLink)
          {
            //localStorage.setItem("AuthToken","");
            //$("#mainbody .modal-backdrop").removeClass("modal-backdrop");
            this.isLockScreen=true;
            // this.isLoginPage = false;
            //this.loginUserName=localStorage.getItem("userName").toString();
            this.getPatientData(accessLink);
            this.updateinfoservice.onIsShowProfilePic();
          }
          else
          {
            this.route.navigateByUrl('/');
          }
        }
        else
        {
          if (params['pa'] != null) {
            sessionStorage.setItem('AccessLink',params['pa']);
            this.getPatientData(params['pa']);           
          }
          else {
            $("#linkexpire-model").modal("show");
          }
        }
          if (params['lf'] != null) {
            console.log("landed from email");
            this.landedFrom = params['lf'];

          }
          else {
            console.log("landed from text");
            this.landedFrom ="Text"
          }
      
      }, error => {
        localStorage.clear();
        $("#linkexpire-model").modal("show");
      });
      this.loadExternalStyles('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0');
      this._phrutilService.setTitle('Appointment Detail');
      
  }

  fileObjFront: any;
  isFrontPhotoUpload: boolean = false;
  defaultImagefront: any;
  onChangeFileFront(event: any) {

    this.fileObjFront = event.target.files[0];
    if (this.fileObjFront) {
      this.showPreview(event, 'front');
      // this.isRequireFrontCard = false;
      event.target.value = '';
      this.OCRDrivingLicenseService();
    }
    else {
      // this.isRequireFrontCard = true;
      return;
    }
  }
  dob: any;
  OCRDrivingLicenseService() {

   // console.log(this.isRequireFrontCard);
    console.log(this.fileObjFront);
    this.spinner.show();
    this._VerifypatientService.OcrDrivingLicense(this.fileObjFront).subscribe((res: any) => {
      this.spinner.hide();
    //  console.log("ins name ",);
      // $("#Captured-Modal").modal("hide");
      console.log("OCR Result ", res);
      if (res && res.Data != null) { 
        if (res && res.Data["License #"] != "Null" && res.Data["DOB"] !="Null") {
        this.dob = res.Data["DOB"]
        this.SubmitDobByCard();
      }
      else {
        //unable to scan card
        $("#scanFail-model").modal("show");
        }
      } else {
        //return null
        $("#scanFail-model").modal("show");
      }

    }, (error: any) => {
      this.spinner.hide();
      $("scanFail-model").modal("show");
    })

  }

  test() {
    console.log("volum icon press");
  }

  selectLanguage(language: string) {
    this.selectedLanguage = language;
    this.currentLang = language;
    this.onLanguageChange();

  }
  onLanguageChange() {
    this.translateService.use(this.selectedLanguage)
    localStorage.setItem('language', this.selectedLanguage);
   // console.log("lang verify modal " + this.selectedLanguage);
    this._phrutilService.setdeafultLanguage(this.selectedLanguage);
    this._phrutilService.setPatientLanguage(this.selectedLanguage);
    this.currentLang = this.selectedLanguage;
    $("#language-modal").modal("hide");
    //console.log("onLanguageChange");
  }
  chnageLanguageModal() {
    $("#language-modal").modal("show");
    let lang = localStorage.getItem('language');
    if (lang) {
      // console.log("verify patient init  " + lang);
      this.currentLang = lang;
      this.selectedLanguage = lang;
     // console.log(this.selectedLanguage);
    }
  }

  loadExternalStyles(url: string) {
    const link = this.renderer.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;

    this.renderer.appendChild(document.head, link);
  }
  populateYears(): void {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 100;
    const endYear = currentYear;

    for (let i = endYear; i >= startYear; i--) {
      this.years.push(i);
    }
  }

  updateDays(event: any) {

    const selectedDay = this.profileForm.controls['dobDay'].value;
    this.selectedMonth = parseInt(this.profileForm.controls['dobMonth'].value, 10);
    this.selectedYear = parseInt(this.profileForm.controls['dobyear'].value, 10) || new Date().getFullYear();

    if (this.selectedMonth) {
      //console.log("inside update days");
      const daysInSelectedMonth = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
     // console.log(daysInSelectedMonth);
      this.daysInMonth = Array.from({ length: daysInSelectedMonth }, (_, i) => i + 1);
      if (selectedDay != '') {
        if (selectedDay > daysInSelectedMonth) {
          this.profileForm.controls['dobDay'].setValue('');
        } else {
          this.profileForm.controls['dobDay'].setValue(selectedDay);
        }
      }
      
    } else {
      this.daysInMonth = Array.from({ length: 31 }, (_, i) => i + 1);
    }
  }
 
  gotoVerify() {
    this.isAppointmentDetail = false;
    this._phrutilService.setTitle('Verify Patient');
    //localStorage.setItem("updateAppointmentStatus", "false")
   //this.UpdateAppointmentstatus();
   // this.showThanksScreen = true;
    setTimeout(() => {
      this.showThanksScreen = false;
      this.verifyPatientScreen = true;
      if (this.patientLanguage == 'en') {
       // $("#language-modal").modal("show");
      }
    }, 5000);
   
  }
    getCurrentTimeZone() {
      
      let currDate = new Date().toString();
      let getOffsetwithTime = currDate.split('(');
      let offSet = getOffsetwithTime[0].substr(getOffsetwithTime[0].length - 9);
      this.currentTimeZone = offSet.trim();
      if(this.currentTimeZone.includes('+'))
      {
        let RemoveAlpht=this.currentTimeZone.split('+');
        this.currentTimeZone='+'+RemoveAlpht[1];
      }
      else if(this.currentTimeZone.includes('-'))
      {
        let RemoveAlpht=this.currentTimeZone.split('-');
        this.currentTimeZone='-'+RemoveAlpht[1];
      }
      console.log(this.currentTimeZone);
    }
  phoneLink: any;
  patientLanguage: any;
  increment: any = 0;
  appointmentid: any;
  isWithin24Hours: any;
  isWithin3Hours: any;
  appointmentAddress: any;
  appointmentCity: any;
  appointmentState: any;
  appointmentZip: any;
    getPatientData(param: any) {
    
      this.spinner.show();
      this._VerifypatientService.getpatientInfocheckinflow(param,this.currentTimeZone).subscribe((res: any) => {
        
        this.spinner.hide();
        if (res.data) {
          if (res.data.status !== 'Fail') {
            //store the access and refreash token in the localStorage
            localStorage.setItem("AuthTokenwebServices", res.data.accessTokenResponse.accessToken);
            sessionStorage.setItem("AuthTokenwebServices", res.data.accessTokenResponse.accessToken);
            localStorage.setItem("RefreashTokenwebServices", res.data.accessTokenResponse.refreshToken);
            localStorage.setItem('pictureAddress', res.data.picture_Address);
            console.log("verii " + res.data.accessTokenResponse.accessToken);
            console.log("verii loc GetData" + localStorage.getItem("AuthTokenwebServices"));
            //console.log(res.data);
            this.getPatientInfo.emailAddress = res.data.emailAddress?this._phrutilService.decryptforServices(res.data.emailAddress):res.data.emailAddress;
            this.getPatientInfo.visitDate = res.data.visitDate;
            localStorage.setItem('visitDate', this.getPatientInfo.visitDate);
            this.getPatientInfo.timE_FROM= res.data.timE_FROM;
            this.getPatientInfo.visitReason= res.data.visitReason;
            this.getPatientInfo.dateOfBirth= res.data.dateOfBirth?this._phrutilService.decryptforServices(res.data.dateOfBirth):res.data.dateOfBirth;
            this.getPatientInfo.cellPhone= res.data.cellPhone?this._phrutilService.decryptforServices(res.data.cellPhone):res.data.cellPhone;
            this.getPatientInfo.firstName= res.data.firstName?this._phrutilService.decryptforServices(res.data.firstName):res.data.firstName;
            this.getPatientInfo.lastName= res.data.lastName?this._phrutilService.decryptforServices(res.data.lastName):res.data.lastName;
            this.getPatientInfo.practiceCode= res.data.practiceCode?this._phrutilService.decryptforServices(res.data.practiceCode):res.data.practiceCode;
            this.getPatientInfo.todaY_AMMOUNT= res.data.todaY_AMMOUNT;
            this.getPatientInfo.previouS_AMMOUNT= res.data.previouS_AMMOUNT;
            this.getPatientInfo.providerLastName= res.data.providerLastName?this._phrutilService.decryptforServices(res.data.providerLastName):res.data.providerLastName;
            this.getPatientInfo.providerFirstName= res.data.providerFirstName?this._phrutilService.decryptforServices(res.data.providerFirstName):res.data.providerFirstName;
            this.getPatientInfo.providerCode= res.data.providerCode?this._phrutilService.decryptforServices(res.data.providerCode):res.data.providerCode;
            this.getPatientInfo.practiceName= res.data.practiceName?this._phrutilService.decryptforServices(res.data.practiceName):res.data.practiceName;
            this.getPatientInfo.patientAccount= res.data.patientAccount?this._phrutilService.decryptforServices(res.data.patientAccount):res.data.patientAccount;
            this.getPatientInfo.appointment_id= res.data.appointment_id?this._phrutilService.decryptforServices(res.data.appointment_id):res.data.appointment_id;
            this.getPatientInfo.practicePhone = res.data.practicePhone ? this._phrutilService.decryptforServices(res.data.practicePhone) : res.data.practicePhone;
            this.getPatientInfo.picture_Address = res.data.picture_Address ? this._phrutilService.decryptforServices(res.data.picture_Address) : res.data.picture_Address;
            this.getPatientInfo.languages = res.data.languages ? this._phrutilService.decryptforServices(res.data.languages) : res.data.languages;
            this.getPatientInfo.practiceAddress = res.data.practiceAddress ? this._phrutilService.decryptforServices(res.data.practiceAddress) : res.data.practiceAddress;
            this.getPatientInfo.PracticeCity = res.data.practiceCity ? this._phrutilService.decryptforServices(res.data.practiceCity) : res.data.practiceCity;
            this.getPatientInfo.practiceState = res.data.practiceState ? this._phrutilService.decryptforServices(res.data.practiceState) : res.data.practiceState;
            this.getPatientInfo.praticeZip = res.data.praticeZip ? this._phrutilService.decryptforServices(res.data.praticeZip) : res.data.praticeZip;
            this.getPatientInfo.praticeZip = this._phrutilService.maskingZipNum(this.getPatientInfo.praticeZip);
            this.getPatientInfo.reason_Id = res.data.reason_Id ? this._phrutilService.decryptforServices(res.data.reason_Id) : res.data.reason_Id;
            this.getPatientInfo.reasonName = res.data.reasonName ? this._phrutilService.decryptforServices(res.data.reasonName) : res.data.reasonName;
            this.getPatientInfo.appointmentStatusId = res.data.appointmentStatusId ? this._phrutilService.decryptforServices(res.data.appointmentStatusId) : res.data.appointmentStatusId;
            this.getPatientInfo.appointment_End_DateTime = res.data.appointment_End_DateTime ? this._phrutilService.decryptforServices(res.data.appointment_End_DateTime) : res.data.appointment_End_DateTime;
            this.getPatientInfo.appointmentDuration = res.data.appointmentDuration ? this._phrutilService.decryptforServices(res.data.appointmentDuration) : res.data.appointmentDuration;
            this.getPatientInfo.appointmentAddress = res.data.appointmentAddress ? this._phrutilService.decryptforServices(res.data.appointmentAddress) : res.data.appointmentAddress;
            this.getPatientInfo.appointmentState = res.data.appointmentState ? this._phrutilService.decryptforServices(res.data.appointmentState) : res.data.appointmentState;
            this.getPatientInfo.appointmentCity = res.data.appointmentCity ? this._phrutilService.decryptforServices(res.data.appointmentCity) : res.data.appointmentCity;
            this.getPatientInfo.appointmentZip = res.data.appointmentZip ? this._phrutilService.decryptforServices(res.data.appointmentZip) : res.data.appointmentZip;
            this.getPatientInfo.appointmentZip = this._phrutilService.maskingZipNum(this.getPatientInfo.appointmentZip);
            this.appointmentAddress = this.getPatientInfo.appointmentAddress ? this.getPatientInfo.appointmentAddress : this.getPatientInfo.practiceAddress;
            this.appointmentState = this.getPatientInfo.appointmentState ? this.getPatientInfo.appointmentState : this.getPatientInfo.practiceState;
            this.appointmentCity = this.getPatientInfo.appointmentCity ? this.getPatientInfo.appointmentCity : this.getPatientInfo.PracticeCity;
            this.appointmentZip = this.getPatientInfo.appointmentZip ? this.getPatientInfo.appointmentZip : this.getPatientInfo.praticeZip;
            this.getPatientInfo.isBreezePaymentEnabled = res.data.isBreezePaymentEnabled;
            this.getPatientInfo.isPayLaterEnabled = res.data.isPayLaterEnabled;
     
            console.log("landed from ", this.landedFrom);
            this.trackPatientPreference(this.landedFrom);
          
       
            //console.log("patient details ",this.getPatientInfo);
            console.log("ispaylater enabled ", this.getPatientInfo.isPayLaterEnabled);
            //this.getPatientInfo.isBreezePaymentEnabled = "1";
            console.log("appt status id ", this.getPatientInfo.appointmentStatusId);
            console.log("appt start time ", this.getPatientInfo.timE_FROM);
            console.log("appt end time ", this.getPatientInfo.appointment_End_DateTime);
            console.log("isBreezePaymentEnabled ", this.getPatientInfo.isBreezePaymentEnabled);
            //console.log("today amount ", this.getPatientInfo.todaY_AMMOUNT);
            //const totalAmount = Number(this.getPatientInfo.todaY_AMMOUNT) + Number(this.getPatientInfo.previouS_AMMOUNT);
            //console.log("total amount ", totalAmount);
            //console.log("previous amount ", this.getPatientInfo.previouS_AMMOUNT);
            // console.log("appt duration ", this.getPatientInfo.appointmentDuration);
            //  console.log(this.getPatientInfo.practiceCode);
            //  console.log(this.getPatientInfo.reasonName);
            localStorage.setItem("apptEndTime", this.getPatientInfo.appointment_End_DateTime);
            localStorage.setItem("apptStartTime", this.getPatientInfo.visitDate);
            localStorage.setItem("pcode", this.getPatientInfo.practiceCode);
            localStorage.setItem("reason", this.getPatientInfo.reasonName);
            localStorage.setItem("state", this.getPatientInfo.practiceState);
            localStorage.setItem("city", this.getPatientInfo.PracticeCity);
            localStorage.setItem("zip", this.getPatientInfo.praticeZip);
            localStorage.setItem("Pcell", this.getPatientInfo.practicePhone);
            localStorage.setItem("Padder", this.getPatientInfo.practiceAddress);
            localStorage.setItem("prcode", this.getPatientInfo.providerCode);
            localStorage.setItem("apptId", this.getPatientInfo.appointment_id);
            localStorage.setItem("apptstId", this.getPatientInfo.appointmentStatusId);
            localStorage.setItem("ptcode", this.getPatientInfo.patientAccount);
            localStorage.setItem("fname", this.getPatientInfo.firstName);
            localStorage.setItem("lname", this.getPatientInfo.lastName);
            localStorage.setItem("isBreezePaymentEnabled", this.getPatientInfo.isBreezePaymentEnabled);
            localStorage.setItem("isPayLaterEnabled", this.getPatientInfo.isPayLaterEnabled);
            localStorage.setItem("apptAddr", this.appointmentAddress);
            localStorage.setItem("apptst", this.appointmentState);
            localStorage.setItem("apptcty", this.appointmentCity);
            localStorage.setItem("aptzip", this.appointmentZip);
      

            this.isWithin3Hours = this.checkinBeforeThreeHours(this.getPatientInfo.visitDate, this.getPatientInfo.timE_FROM);
            localStorage.setItem('isWithin3Hours', this.isWithin3Hours);
            console.log("is with in 3 hours " + this.isWithin3Hours)
            if ((this.getPatientInfo.practiceCode == '1011163' || this.getPatientInfo.practiceCode == '100') && this.getPatientInfo.reasonName == 'Initial Visit') {
             // console.log("using zahid function " + this.ConverttoLocalDate(this.getPatientInfo.visitDate));
              this.isWithin24Hours = this.checkIfVisitWithin24Hours(this.getPatientInfo.visitDate, this.getPatientInfo.timE_FROM);
              console.log("is Same date "+this.isWithin24Hours); // Output: true or false
              localStorage.setItem('isWithin24Hours', this.isWithin24Hours);
            }
         
            this.appointmentid = this.getPatientInfo.appointment_id;
           // localStorage.setItem("appointmentid", this.getPatientInfo.appointment_id);
            this._phrutilService.setNavbarLastName(this.getPatientInfo.lastName);
            this._phrutilService.setNavpracName(this.getPatientInfo.practiceName);
            console.log(this.getPatientInfo.languages + "language");
            if (this.getPatientInfo.languages == 'Spanish') {
              this.patientLanguage = 'es';
             localStorage.setItem('language', this.patientLanguage);
               this.selectedLanguage = this.patientLanguage;
               this.translateService.use(this.selectedLanguage)
              this._phrutilService.setdeafultLanguage(this.selectedLanguage);
              this._phrutilService.setPatientLanguage(this.selectedLanguage);
              this.currentLang = this.selectedLanguage;
            console.log(this.selectedLanguage);
            } else if (this.getPatientInfo.languages == 'Hindi') {
              this.patientLanguage = 'hi';
              localStorage.setItem('language', this.patientLanguage);
              this.selectedLanguage = this.patientLanguage;
              this.translateService.use(this.selectedLanguage)
              this._phrutilService.setdeafultLanguage(this.selectedLanguage);
              this._phrutilService.setPatientLanguage(this.selectedLanguage);
              console.log(this.selectedLanguage);
              this.currentLang = this.selectedLanguage;
            } else if (this.getPatientInfo.languages == 'Urdu') {
              this.patientLanguage = 'ur';
              localStorage.setItem('language', this.patientLanguage);
              this.selectedLanguage = this.patientLanguage;
              this.translateService.use(this.selectedLanguage)
              this._phrutilService.setdeafultLanguage(this.selectedLanguage);
              this._phrutilService.setPatientLanguage(this.selectedLanguage);
              console.log(this.selectedLanguage);
              this.currentLang = this.selectedLanguage;
            } else {
               this.patientLanguage = 'en';
               localStorage.setItem('language', this.patientLanguage);
               this.selectedLanguage = this.patientLanguage;
               this.translateService.use(this.selectedLanguage)
              this._phrutilService.setdeafultLanguage(this.selectedLanguage);
              this._phrutilService.setPatientLanguage(this.selectedLanguage);
              $("#language-modal").modal("show");
              this.currentLang = this.selectedLanguage;
            }
           
            if(this.getPatientInfo.practicePhone)
            {
              this.phoneLink =  "tel:+1"+this.getPatientInfo.practicePhone;
              this.getPatientInfo.practicePhone = this._phrutilService.maskingPhoneNumer(this.getPatientInfo.practicePhone);
            }
            
                // Log Rocket Implementation
                const LogRocket = require('logrocket/setup')({
                  sdkServer: 'https://logrocket.carecloud.com',
                  ingestServer: 'https://logrocket.carecloud.com'
                });
                LogRocket.init('carecloud/breeze-checkin');
                LogRocket.startNewSession();
                LogRocket.identify(this.getPatientInfo.patientAccount, {
                  name: this.getPatientInfo.patientAccount,
                  email: this.getPatientInfo.emailAddress,
                  // Add your own custom user variables here, ie:
                  subscriptionType: 'pro'
                });

            //console.log('record ', this.getPatientInfo);
            /*
            if (this.getPatientInfo.appointmentStatusId == '15') {
              console.log("inside appointment start");
              localStorage.setItem("checkin", 'true')
              localStorage.setItem("alredycheckin", 'true');
              localStorage.setItem("noIntakeForm", "true");
              this.route.navigateByUrl('patient/thank-you');
              console.log("inside appointment end");
             
            }*/
            // this.auth.USER_NAME = "breezecheckin";
            // this.auth.PWD = "tci@1234";

            // this._VerifypatientService.Authentication(this.auth).subscribe((res:any) =>{

            //   localStorage.setItem("AuthToken",res.RESPONSE.token);
            // })

            /*
            try {

              let token = localStorage.getItem("AuthTokenwebServices")
              if (!token || token == '' || token == undefined || token==null || token=='null') {
                console.log("--Start We are getting AuthTokenwebServices " + token + " that's why we are getting patient data again --Start");
                const accessLink = sessionStorage.getItem('AccessLink');
                if (this.increment < 3) {
                  this.getPatientData(accessLink);
                  console.log("--END We are getting AuthTokenwebServices " + token + " that's why we are getting patient data again --END");
                }
                this.increment = this.increment + 1;
              }
            } catch (error) {
              this.increment = 4;
            } */
          
          }
          else {
           // this.getPatientAppointmentData(param);
            $("#linkexpire-model").modal("show");
            return;
          }
          
        }
        else {
          $("#linkexpire-model").modal("show");
          return;
        }
      }, (error: any) => {
        this.spinner.hide();
        $("#linkexpire-model").modal("show");
        return;
      });
  }
  // past day appointment check
  getPatientAppointmentData(param: any) {

    this.spinner.show();
    this._VerifypatientService.getpatientAppointmentInfo(param, this.currentTimeZone).subscribe((res: any) => {
      this.spinner.hide();
      console.log(res);
      this.getPatientInfo.emailAddress = res.data.emailAddress ? this._phrutilService.decryptforServices(res.data.emailAddress) : res.data.emailAddress;
      this.getPatientInfo.visitDate = res.data.visitDate;
      this.getPatientInfo.timE_FROM = res.data.timE_FROM;
      this.getPatientInfo.visitReason = res.data.visitReason;
      this.getPatientInfo.dateOfBirth = res.data.dateOfBirth ? this._phrutilService.decryptforServices(res.data.dateOfBirth) : res.data.dateOfBirth;
      this.getPatientInfo.cellPhone = res.data.cellPhone ? this._phrutilService.decryptforServices(res.data.cellPhone) : res.data.cellPhone;
      this.getPatientInfo.firstName = res.data.firstName ? this._phrutilService.decryptforServices(res.data.firstName) : res.data.firstName;
      this.getPatientInfo.lastName = res.data.lastName ? this._phrutilService.decryptforServices(res.data.lastName) : res.data.lastName;
      this.getPatientInfo.practiceCode = res.data.practiceCode ? this._phrutilService.decryptforServices(res.data.practiceCode) : res.data.practiceCode;
      this.getPatientInfo.todaY_AMMOUNT = res.data.todaY_AMMOUNT;
      this.getPatientInfo.previouS_AMMOUNT = res.data.previouS_AMMOUNT;
      this.getPatientInfo.providerLastName = res.data.providerLastName ? this._phrutilService.decryptforServices(res.data.providerLastName) : res.data.providerLastName;
      this.getPatientInfo.providerFirstName = res.data.providerFirstName ? this._phrutilService.decryptforServices(res.data.providerFirstName) : res.data.providerFirstName;
      this.getPatientInfo.providerCode = res.data.providerCode ? this._phrutilService.decryptforServices(res.data.providerCode) : res.data.providerCode;
      this.getPatientInfo.practiceName = res.data.practiceName ? this._phrutilService.decryptforServices(res.data.practiceName) : res.data.practiceName;
      this.getPatientInfo.patientAccount = res.data.patientAccount ? this._phrutilService.decryptforServices(res.data.patientAccount) : res.data.patientAccount;
      this.getPatientInfo.appointment_id = res.data.appointment_id ? this._phrutilService.decryptforServices(res.data.appointment_id) : res.data.appointment_id;
      this.getPatientInfo.practicePhone = res.data.practicePhone ? this._phrutilService.decryptforServices(res.data.practicePhone) : res.data.practicePhone;
      this.getPatientInfo.picture_Address = res.data.picture_Address ? this._phrutilService.decryptforServices(res.data.picture_Address) : res.data.picture_Address;
      this.getPatientInfo.languages = res.data.languages ? this._phrutilService.decryptforServices(res.data.languages) : res.data.languages;
      this.getPatientInfo.practiceAddress = res.data.practiceAddress ? this._phrutilService.decryptforServices(res.data.practiceAddress) : res.data.practiceAddress;
      this.getPatientInfo.PracticeCity = res.data.practiceCity ? this._phrutilService.decryptforServices(res.data.practiceCity) : res.data.practiceCity;
      this.getPatientInfo.practiceState = res.data.practiceState ? this._phrutilService.decryptforServices(res.data.practiceState) : res.data.practiceState;
      this.getPatientInfo.praticeZip = res.data.praticeZip ? this._phrutilService.decryptforServices(res.data.praticeZip) : res.data.praticeZip;
      this.getPatientInfo.praticeZip = this._phrutilService.maskingZipNum(this.getPatientInfo.praticeZip);
      this.getPatientInfo.reason_Id = res.data.reason_Id ? this._phrutilService.decryptforServices(res.data.reason_Id) : res.data.reason_Id;
      this.getPatientInfo.reasonName = res.data.reasonName ? this._phrutilService.decryptforServices(res.data.reasonName) : res.data.reasonName;
      this.getPatientInfo.appointmentStatusId = res.data.appointmentStatusId ? this._phrutilService.decryptforServices(res.data.appointmentStatusId) : res.data.appointmentStatusId;
      this.getPatientInfo.appointment_End_DateTime = res.data.appointment_End_DateTime ? this._phrutilService.decryptforServices(res.data.appointment_End_DateTime) : res.data.appointment_End_DateTime;
      this.getPatientInfo.appointmentDuration = res.data.appointmentDuration ? this._phrutilService.decryptforServices(res.data.appointmentDuration) : res.data.appointmentDuration;


      this.getPatientInfo.isBreezePaymentEnabled = res.data.isBreezePaymentEnabled;
      this.getPatientInfo.isPayLaterEnabled = res.data.isPayLaterEnabled;
      this.isPreviousdatAppointmetn = this.checkAppointmentDate(this.getPatientInfo.visitDate)
      console.log("past appointment", this.isPreviousdatAppointmetn);
      if (this.isPreviousdatAppointmetn) {
        $("#PreviousDayAppointment_model").modal("show");
        return;
      } else {
        $("#linkexpire-model").modal("show");
        return;
      }
 

    }, (error: any) => {
      this.spinner.hide();
      $("#linkexpire-model").modal("show");
      return;
    })
  }
  isPreviousdatAppointmetn:any
  checkAppointmentDate(visitDate:any) {
    const visitDateTime = this.ConverttoLocalDate(visitDate);
    console.log("visit date time " + visitDateTime);
    console.log("visit date time " + typeof visitDateTime);

    const currentDateTime = this.ConverttoLocalDate(new Date());
    console.log("current date time " + currentDateTime);
    console.log("current date time " + typeof currentDateTime);


    if ((visitDateTime.trim() < currentDateTime.trim())) {
      return true;
    } else {
      return false;
    }
  }
  ObjAction: any = {};
  trackPatientPreference(lf:any) {
    console.log("landed from ", lf);
    this.ObjAction['patientAccount'] = this.getPatientInfo.patientAccount;
    this.ObjAction['practiceCode'] = this.getPatientInfo.practiceCode;
    this.ObjAction['appointmentID'] = this.getPatientInfo.appointment_id;
    this.ObjAction['action'] = lf;
    this.ObjAction['createdBy'] = this.getPatientInfo.firstName + " " + this.getPatientInfo.lastName;
    this.ObjAction['appSource'] = "breezeCheckin";
    console.log("action object ", this.ObjAction);
    this._VerifypatientService.ManageActionItems(this.ObjAction).subscribe((res: any) => {
      console.log(res);      
    }, (error:any) => {
      console.log(error); 
    })
    
  }

  checkIfVisitWithin24Hours(visitDate: string, visitTime: string): boolean {

    const visitDateTime = this.ConverttoLocalDate(visitDate);
    console.log("visit date time " + visitDateTime);
    console.log("visit date time " + typeof visitDateTime);
 

   // const currentDateFormatted = this.getCurrentDateFormatted();
   // console.log("current date with format " + currentDateFormatted)
    


    const currentDateTime = this.ConverttoLocalDate(new Date());
    console.log("current date time " + currentDateTime);
    console.log("current date time " + typeof currentDateTime);


    // Add one day to today's date
    const nextDay = this.ConverttoLocalDateInDay(new Date());
    nextDay.setDate(nextDay.getDate() + 1);



    const nextDaydate = this.ConverttoLocalDate(nextDay);
    console.log("next day date " + nextDaydate);
    //console.log("current date time " + typeof currentDateTime);

    if ((visitDateTime.trim() === currentDateTime.trim()) || (visitDateTime.trim() === nextDaydate.trim())) {
      return true;
    } else {
      return false;
    }
  }



  AppointmentStatusConfirmed: any;
  UpdateAppointmentstatus() {
    //tM2hXGTAFn9xY21Pd7JGYg==
    // this.appointmentid;
    this.AppointmentStatusConfirmed = 2;
    this._VerifypatientService.ConfirmAppointment(this.appointmentid, this.AppointmentStatusConfirmed).subscribe((res: any) => {
      console.log(res)
      if (res.message == "Record Updated") {
        localStorage.setItem("updateAppointmentStatus", "true")
      } else {
        localStorage.setItem("updateAppointmentStatus", "false")
      }

     
    })
  }
  SubmitDobByCard() {
    if (this.getPatientInfo.practiceCode) {
        this.spinner.show();

        this.VerifypatientModule.DOB = this.dob;
        this.VerifypatientModule.PRACTICE_CODE = this.getPatientInfo.practiceCode.toString();

        this.VerifypatientModule.LAST_NAME = this.getPatientInfo.lastName;

        this.VerifypatientModule.FIRST_NAME = this.getPatientInfo.firstName;

        this.VerifypatientModule.APPOINTMENT_ID = this.getPatientInfo.appointment_id;
        this._VerifypatientService.VerifyPatient_v1(this.VerifypatientModule).subscribe((res: any) => {

          this.spinner.hide();
          if (res.RESPONSE[0]) {

            this.PatientPersonalInfo = res.RESPONSE[0] as PatientPersonalInfo;
            this.PatientPersonalInfo.PRACTICE_CODE = this.VerifypatientModule.PRACTICE_CODE;
            this.PatientPersonalInfo.isShowpicture = true;
            this.PatientPersonalInfo.PracticeName = this.getPatientInfo.practiceName;
            this.PatientPersonalInfo.PROVIDER_CODE = this.getPatientInfo.providerCode;
            let data = this._phrutilService.encrypt(this.PatientPersonalInfo);

            console.log("verii loc " + localStorage.getItem("AuthTokenwebServices"));
            localStorage.setItem('PersonalInfo', data);
            localStorage.setItem("AuthToken", res.RESPONSE[0].ACCESS_TOKEN);
            localStorage.setItem('patientAccount', this.PatientPersonalInfo.PATIENT_ACCOUNT)
            localStorage.setItem('userName', this.PatientPersonalInfo.EMAIL_ADDRESS)
            this.updateinfoservice.onIsShowProfilePic();
            this._VerifypatientService.startRefreshTokenTimer();

           
            if (this.isLockScreen) {
              localStorage.setItem("lockscreen", "true");
              this.route.navigateByUrl('/patient/consent-form');
            }
            else
              this.route.navigateByUrl('/patient/consent-form');


          } else {
            $("#incorrectinfo-model").modal("show");
          }
        }, (error: any) => {
          $("#incorrectinfo-model").modal("show");
          this.spinner.hide();
        })
     
    } else {
      let text = "Service is not available, please try later.";
      $("#linkexpire-model").modal("show");
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
    }

  }
    onSubmit() {
      if(this.getPatientInfo.practiceCode)
      {
        if (this.profileForm.valid) {
          this.spinner.show();
         
          const dobDay = this.profileForm.controls['dobDay'].value;
          const dobMonth = this.profileForm.controls['dobMonth'].value;
         
          const dobYear = this.profileForm.controls['dobyear'].value;
 
         // const paddedDobDay = dobDay.toString().padStart(2, '0');
         // const paddedDobMonth = dobMonth.toString().padStart(2, '0');
         // var dateOfBirth = dobYear + "-" + paddedDobMonth + "-" + paddedDobDay;
         // var dobDate = new Date(dateOfBirth);
          const formattedDate = dobMonth + "/" + dobDay + "/" + dobYear;
          //const formattedDate = this.datepipe.transform(dobDate, 'MM/dd/yyyy');
        
          this.VerifypatientModule.DOB = formattedDate;
          this.VerifypatientModule.PRACTICE_CODE = this.getPatientInfo.practiceCode.toString();
          //this.VerifypatientModule.PRACTICE_CODE = '1011163';
          //this.VerifypatientModule.LAST_NAME = this.profileForm.controls['lastName'].value.trim();
          this.VerifypatientModule.LAST_NAME = this.getPatientInfo.lastName;
         // this.VerifypatientModule.FIRST_NAME = this.profileForm.controls['firstName'].value.trim();
          this.VerifypatientModule.FIRST_NAME = this.getPatientInfo.firstName;
         // this.VerifypatientModule.DOB = this.datepipe.transform(this.profileForm.controls['dob'].value, 'MM/dd/yyyy');
          this.VerifypatientModule.APPOINTMENT_ID=this.getPatientInfo.appointment_id;
            this._VerifypatientService.VerifyPatient_v1(this.VerifypatientModule).subscribe((res: any) => {
              //this._VerifypatientService.VerifyPatient(this.VerifypatientModule).subscribe((res: any) => {

              this.spinner.hide();
              if (res.RESPONSE[0]) {

                this.PatientPersonalInfo = res.RESPONSE[0] as PatientPersonalInfo;
                this.PatientPersonalInfo.PRACTICE_CODE = this.VerifypatientModule.PRACTICE_CODE;
                this.PatientPersonalInfo.isShowpicture = true;
                this.PatientPersonalInfo.PracticeName = this.getPatientInfo.practiceName;
                this.PatientPersonalInfo.PROVIDER_CODE = this.getPatientInfo.providerCode;
                let data = this._phrutilService.encrypt(this.PatientPersonalInfo);
                
                console.log("verii loc " + localStorage.getItem("AuthTokenwebServices"));
                localStorage.setItem('PersonalInfo', data);
                localStorage.setItem("AuthToken",res.RESPONSE[0].ACCESS_TOKEN);
                localStorage.setItem('patientAccount', this.PatientPersonalInfo.PATIENT_ACCOUNT)
                localStorage.setItem('userName', this.PatientPersonalInfo.EMAIL_ADDRESS)
                this.updateinfoservice.onIsShowProfilePic();
                this._VerifypatientService.startRefreshTokenTimer();

                // Log Rocket Implementation
                /*const LogRocket = require('logrocket/setup')({
                  sdkServer: 'https://logrocket.carecloud.com',
                  ingestServer: 'https://logrocket.carecloud.com'
                });
                LogRocket.init('carecloud/breeze-checkin');
                LogRocket.startNewSession();
                LogRocket.identify(localStorage.getItem('patientAccount'), {
                  name: localStorage.getItem('patientAccount'),
                  email: localStorage.getItem('userName'),
                  // Add your own custom user variables here, ie:
                  subscriptionType: 'pro'
                });*/
                /*
                if (this.getPatientInfo.appointmentStatusId == '15') {
               
                  console.log("inside appointment start");
                  localStorage.setItem("checkin", 'true')
                  localStorage.setItem("alredycheckin", 'true');
                  console.log("inside appointment end");
                  this.getPaymentDetails();

                }*/
                  if (this.isLockScreen) {
                    // let visitURL = sessionStorage.getItem("VisitedURL");
                    // this.route.navigateByUrl(visitURL?visitURL:'/');
                    //check if the session is from lock screen the redirect on consent form and check the last visited URL
                    localStorage.setItem("lockscreen", "true");
                    this.route.navigateByUrl('/patient/consent-form');
                  }
                  else
                    this.route.navigateByUrl('/patient/consent-form');
                

              } else {
                $("#incorrectinfo-model").modal("show");
              }
            }, (error: any) => {
              $("#incorrectinfo-model").modal("show");
              this.spinner.hide();
            })   
        }else {
          this.profileForm.markAllAsTouched();
        }
      }else
      {
        let text ="Service is not available, please try later.";
        $("#linkexpire-model").modal("show");
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
      }
      
    }
    onlyCharAllow(event: any,type:any) {
      if(event.value.trim())
      {
        let validname=event.value.replace(/[^a-zA-Z ]/g, "");
        event.value=validname;
      }
      else
      {
        event.value = event.value.trim();
        this.profileForm.controls[type].setValue(event.value);
      }    
  }

  checkinBeforeThreeHours(visitDate: any, visitTime: any) {
    try {
      // Combine visitDate and visitTime into a single string
      const visitDateTimeStr = `${visitDate} ${visitTime}`;

      // Parse visit date and time into a Date object without converting to local timezone
      const visitDateTime = this.ConverttoLocalDateForDiff(visitDateTimeStr);
      console.log("3 hour visit date time: " + visitDateTime);

      // Get the current date and time in UTC
      const currentDateTime = this.ConverttoLocalDateForDiff(new Date());
      console.log("3 hour current date time: " + currentDateTime);

      // Calculate the difference in milliseconds
      const diffInMs = visitDateTime.getTime() - currentDateTime.getTime();

      // Convert the difference to hours
      const diffInHours = diffInMs / (1000 * 60 * 60);
      console.log("3 hour difference: " + diffInHours);

      // Check if the difference is within 3 hours
      return diffInHours <= 3 && diffInHours >= 0;
    } catch (error) {
      console.error("An error occurred while calculating the time difference:", error);
      // Return false if an error occurs
      return false;
    }
  
  }


  ConverttoLocalDate(date:any): string {
   // if (!date) return '';

    if (date instanceof Date) {
      date = this.hasTimezone(date) ? this.removeZ(date) : date;
     
     // date = moment(date).format('MM/DD/Y h:mm:ss');
      date = moment(date).format('MM/DD/YYYY');
     // date = new Date(date);
    }

    return date;
  }

  ConverttoLocalDateInDay(date: any): Date {
    // if (!date) return '';

    if (date instanceof Date) {
      date = this.hasTimezone(date) ? this.removeZ(date) : date;

      // date = moment(date).format('MM/DD/Y h:mm:ss');
      date = moment(date).format('MM/DD/YYYY');
       date = new Date(date);
    }

    return date;
  }

  ConverttoLocalDateForDiff(date: any): Date {
    // if (!date) return '';

   // if (date instanceof Date) {
      date = this.hasTimezone(date) ? this.removeZ(date) : date;

      date = moment(date).format('MM/DD/Y h:mm:ss');
      //date = moment(date).format('MM/DD/YYYY');
      date = new Date(date);
    
   // }
 
    return date;
  }


  private hasTimezone(value:any) {
    if (typeof value !== 'string') return false;
    return (value.includes('T') || value.includes('t'));
  }

  private removeZ(value:any) {
    if (!value) return '';
    return value.replace(/z|Z/, '');
  }
  paymentDetials: PaymentDeiails = new PaymentDeiails();
  getPaymentDetails() {
    this.spinner.show();
    this.service.getPaymentDetails(this.getPatientInfo.practiceCode, this.getPatientInfo.patientAccount, this.getPatientInfo.appointment_id).subscribe((res: any) => {
      this.spinner.hide();
      //   { "statusCode": 200, "message": "SUCCESS","data": { "amT_DUE": "492.90", "currentDayAmount": "0.00",
      //         "totalAmount": "492.90",
      //         "prI_SEC_OTH_TYPE": "P", "id": "1", "inspayeR_DESCRIPTION": "MEDICARE ADVANTAGE", "visit_Date": "",
      //         "visit_Reasons": ""  } }
      if (res && res.statusCode == 200 && res.message == 'SUCCESS' && res.data) {
        this.paymentDetials = res as PaymentDeiails;
        if (this.paymentDetials.data.totalAmount != null && this.paymentDetials.data.totalAmount != "") {
          if (Number(this.paymentDetials.data.totalAmount) <= 0 && this.getPatientInfo.appointmentStatusId == "15") {
            localStorage.setItem("noIntakeForm", "true");
            this.route.navigateByUrl('patient/thank-you');
          } else {
            this.route.navigateByUrl('patient/payment-overview');
          } 
        }
     
        this.paymentDetials.data.amT_DUE = Number(this.paymentDetials.data.amT_DUE).toFixed(2).toLocaleString();
        this.paymentDetials.data.totalAmount = Number(this.paymentDetials.data.totalAmount).toFixed(2).toLocaleString();
 
     
      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      //this._phrutilService.showError(text);
      //this.phrUtils.showError("Service is not available, please try later.");
    });
  }

  //show local image
  showPreview(event: Event, type: any) {
    let selectedFile = (event.target as HTMLInputElement).files?.item(0)
    if (selectedFile) {
      if (["image/jpeg", "image/png", "image/svg+xml", "image/gif"].includes(selectedFile.type)) {
        let fileReader = new FileReader();
        fileReader.readAsDataURL(selectedFile);
        fileReader.addEventListener('load', (event) => {
            console.log("front");
            this.isFrontPhotoUpload = true;
            this.defaultImagefront = event.target?.result;
          
        })
      }
    }
  }

  }
